import * as constants from './constants'
import * as ReducerHelper from '@eig-builder/core-utils/helpers/reducer-helper'

import { sort } from '../../../helpers/sort-helper'

const initialState = {
  getFlaggedSitesRetrieving: false,
  getFlaggedAccountsRetrieving: false,
  flagged: [],
  getSuspiciousWordTypesRetrieving: false,
  getSuspiciousWordsRetrieving: false,
  getSuspiciousWordTypesResponse: null,
  getSuspiciousWordsResponse: [],
  addSuspiciousWordRetrieving: false,
  addSuspiciousWordResponse: null,
  deleteSuspiciousWordPending: false,
  deleteSuspiciousWordSuccess: null,
  getSanctionsListResponse: [],
  getSanctionsListRetrieving: false
}

const merge = (flagged, result) => {
  const merged = flagged.concat(result)
  return merged.sort(sort('created', true))
}

export default (state = initialState, action) => {
  const listenState =
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FLAGGED_SITES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_FLAGGED_STATUS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FLAGGED_SITES_COUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FLAGGED_ACCOUNTS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_FLAGGED_ACCOUNTS_COUNT) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SUSPICIOUS_WORD_TYPES) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SUSPICIOUS_WORDS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.ADD_SUSPICIOUS_WORD) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_SEARCH_FRAUD_PREVENTION_LOGS) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_SANCTIONS_LIST) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_SDN_CHANGE) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_ADULT_THRESHOLD) ||
    ReducerHelper.listenToFetchActions(state, action, constants.GET_PUBLISHED_SITES_THRESHOLD) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_ADULT_THRESHOLD) ||
    ReducerHelper.listenToFetchActions(state, action, constants.POST_PUBLISHED_SITES_THRESHOLD) ||
    state

  switch (action.type) {
    case constants.GET_FLAGGED_SITES_FULFILLED:
      const flagged = merge(state.flagged, action.body.result)
      return {
        ...state,
        flagged,
        getFlaggedSitesRetrieving: false
      }
    case constants.GET_FLAGGED_ACCOUNTS_FULFILLED:
      const flaggedMerged = merge(state.flagged, action.body.result)
      return {
        ...state,
        flagged: flaggedMerged,
        getFlaggedAccountsRetrieving: false
      }
    case constants.CLEAR_FLAGGED:
      return {
        ...state,
        flagged: []
      }
    case constants.DELETE_SUSPICIOUS_WORD_PENDING:
      return {
        ...state,
        deleteSuspiciousWordPending: true,
        deleteSuspiciousWordSuccess: null
      }
    case constants.DELETE_SUSPICIOUS_WORD_FULFILLED:
      return {
        ...state,
        deleteSuspiciousWordPending: false,
        deleteSuspiciousWordSuccess: true
      }
    case constants.DELETE_SUSPICIOUS_WORD_ERROR:
      return {
        ...state,
        deleteSuspiciousWordPending: false,
        deleteSuspiciousWordSuccess: false
      }
    case constants.RESET_POST_RESPONSE:
      return {
        ...state,
        addSuspiciousWordResponse: null
      }
    case constants.RESET_DELETE_RESPONSE:
      return {
        ...state,
        deleteSuspiciousWordSuccess: null
      }
    case constants.POST_FLAGGED_STATUS_PENDING:
      const updatedFlaggedSites = state.flagged.filter(site => {
        const siteId = action.extraArguments && action.extraArguments.siteId
        if (siteId) {
          return site.siteId !== siteId
        }

        const accountId = action.extraArguments && action.extraArguments.accountId
        if (accountId) {
          return site.accountId !== accountId || (site.accountId === accountId && site.siteId)
        }

        return true
      })

      return {
        ...state,
        flagged: updatedFlaggedSites,
        postFlaggedStatusResponse: null,
        postFlaggedStatusRetrieving: true,
        postFlaggedStatusError: null
      }
    case constants.POST_FLAGGED_STATUS_FULFILLED:
      return {
        ...state,
        postFlaggedStatusResponse: action.extraArguments.siteId,
        postFlaggedStatusRetrieving: false
      }
    case constants.POST_ADULT_THRESHOLD_PENDING:
      return {
        ...state,
        postAdultThresholdResponse: false,
        postAdultThresholdRetrieving: true,
        postAdultThresholdError: null
      }
    case constants.POST_ADULT_THRESHOLD_FULFILLED:
      return {
        ...state,
        postAdultThresholdResponse: true,
        postAdultThresholdRetrieving: false
      }
    case constants.RESET_ADULT_THRESHOLD:
      return {
        ...state,
        postAdultThresholdResponse: false,
        postAdultThresholdRetrieving: false,
        postAdultThresholdError: null
      }
    case constants.POST_PUBLISHED_SITES_THRESHOLD_PENDING:
      return {
        ...state,
        postPublishedSitesThresholdResponse: false,
        postPublishedSitesThresholdRetrieving: true,
        postPublishedSitesThresholdError: null
      }
    case constants.POST_PUBLISHED_SITES_THRESHOLD_FULFILLED:
      return {
        ...state,
        postPublishedSitesThresholdResponse: true,
        postPublishedSitesThresholdRetrieving: false
      }
    case constants.RESET_PUBLISHED_SITES_THRESHOLD:
      return {
        ...state,
        postPublishedSitesThresholdResponse: false,
        postPublishedSitesThresholdRetrieving: false,
        postPublishedSitesThresholdError: null
      }
  }

  if (listenState) {
    return listenState
  }
}
